<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-app id="inspire" light>
      <v-card color="grey lighten-4" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title class="baslikfont">{{ $t('Statement-Company-Credit-Card') }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field flat="" v-show="!detay" solo-inverted="" hide-details v-model="search3" :label="$t('Search')"
                append-icon="search">
              </v-text-field>
              <v-text-field flat="" v-show="detay" solo-inverted="" hide-details v-model="searchdetay" :label="$t('Search')"
                append-icon="search">
              </v-text-field>
<v-btn color="pink lighten-1" dark @click="openMailDialog" small>
  <v-icon left>email</v-icon> Mail Gönder
</v-btn>

              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title>Html {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>


                  <v-list-tile @click="getListExcel()" v-if="PB=='TRY'">
                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>


<!-- MAIL GÖNDER DIALOG -->
<v-dialog v-model="mailDialog" persistent max-width="640px" scrollable>
  <v-card>
    <v-toolbar dense flat color="info" dark>
      <v-toolbar-title>Mail Gönder</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="closeMailDialog"><v-icon>close</v-icon></v-btn>
    </v-toolbar>

    <v-card-text>
      <v-form ref="mailForm" v-model="mailValid" lazy-validation>
        <v-layout wrap>
          <v-flex xs12>
            <v-text-field
              v-model="mailPayload.To"
              label="Kime (e-posta)"
              :rules="[rules.required, rules.email]"
              clearable
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="mailPayload.AgencyName"
              label="Agency Name"
              :rules="[rules.required]"
              clearable
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="mailPayload.DocType"
              label="Doc Type (sabit)"
              :rules="[rules.required]"
              :disabled="true"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="mailPayload.AgentFullName"
              label="Agent Full Name"
              :rules="[rules.required]"
              clearable
            ></v-text-field>
          </v-flex>

          <v-flex xs12>
            <v-textarea
              v-model="mailPayload.CustomBody"
              label="Mesaj"
              :rules="[rules.required]"
              auto-grow
              rows="3"
            ></v-textarea>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card-text>

    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="closeMailDialog">Vazgeç</v-btn>
      <v-btn
        color="info"
        :loading="mailLoading"
        :disabled="!mailValid || mailLoading"
        @click="sendMail"
      >
        <v-icon left>send</v-icon>Gönder
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
          <v-container v-show="detay==false" fluid="">
            <v-layout row wrap>

              <v-flex xs12 sm6 md6 style="padding-right:2px;">
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">add_comment</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">

                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm3 md12>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  {{ totalCount }}
                                </span>
                              </v-list-tile-title>
                            </v-flex>

                          </v-layout>
                        </v-flex>


                      </v-card-title>

                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="subheading font-weight-bold">  {{$t('totalnumber')}}</span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>


              <v-flex xs12 sm6 md6 style="padding-right:2px;">
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">cached</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm3 md12>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  {{ totalAmount | moneyformat }} {{getparabirimi()}}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-card-title>
                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="subheading font-weight-bold">{{$t('totalnumber')}}</span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>


            </v-layout>
            <v-card color="grey lighten-5" flat>
              <v-form ref="formtarih" v-model="valid" lazy-validation>
                <v-layout pt-2 row wrap>
                  <v-flex xs12 sm6 md2>
                    <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false"
                      :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'" v-bind:value="date"
                      v-model="date"></tarihcomp>
                  </v-flex>
                  <v-flex xs12 sm6 md2>
                    <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false"
                      :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'" v-bind:value="date2"
                      v-model="date2"></tarihcomp>
                  </v-flex>

                  <v-flex>
                    <v-layout>
                      <div v-if="load1">
                        <v-btn color="info" @click="getList()" fab small="" dark>
                          <v-icon>search</v-icon>
                        </v-btn>
                      </div>

                      <v-badge color="white" :overlap="true">
                        <template v-slot:badge>
                          <v-icon v-if="filtrevarmi" large color="green">
                            check_circle_outline </v-icon>
                        </template>

                        <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                          @click="filtrele()" color="info" fab dark>
                          <v-icon>filter_list</v-icon>
                        </v-btn>
                        <v-tooltip bottom="" :activator="el" v-model="tooltip">
                          <span>{{$t('Add-Search-Filter')}}</span>
                        </v-tooltip>



                      </v-badge>


                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm1>
                  </v-flex>



                  <v-flex xs12 sm12>
                    <v-card flat>
                      <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="items"
                        item-key="ToplamAdet" :search="search3">

                        <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                        <template slot="items" slot-scope="props">
                          <!-- <tr @click="props.expanded = !props.expanded"> -->

                          <tr item>
                            <td class="text-xs-left">{{ props.item.FirmaKartNo }}</td>
                            <td class="text-xs-left">{{ props.item.ToplamAdet }}</td>
                            <td class="text-xs-right">{{ props.item.ToplamServis | moneyformat }}</td>
                            <td class="text-xs-right">{{ props.item.ToplamTutar | moneyformat }}</td>
                            <v-btn icon class="mx-0" @click="getir(props.item.EkstreBilgi, props.item.FirmaKartNo)">
                              <v-icon color="teal">line_weight</v-icon>
                            </v-btn>
                          </tr>
                        </template>
                        <template slot="expand" slot-scope="props">

                          <v-data-table hide-actions="" :headers="headers2" :items="props.item.List">
                            <template slot="items" slot-scope="props">
                              <tr style=" background-color:#E6EE9C">
                                <td class="text-xs-left">{{ props.item.Current }}</td>
                                <td class="text-xs-left">{{ props.item.Date }}</td>
                              </tr>
                            </template>
                          </v-data-table>
                        </template>

                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                          {{ $t('No-records-searched-for', { value: search3}) }}
                        </v-alert>
                      </v-data-table>
                    </v-card>


                    <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
                      :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'"
                      v-model="snackbar">
                      {{ text1 }}
                      <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
                    </v-snackbar>
                  </v-flex>


                  <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="450px">
                    <v-card color="grey lighten-5">
                      <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
                      <v-divider></v-divider>
                      <v-card-text>
                        <v-flex pa-1 xs12 sm12 md12>
                          <v-card flat>
                            <v-card color="grey lighten-5" flat="">
                              <v-card-actions>
                                <v-layout row="" wrap="">
                                  <cariaracomp v-bind:etiket="$t('Currentcode_label')" :loading="loading" v-bind:value="EkstreHesap.CariKod" v-model="EkstreHesap.CariKod" ></cariaracomp>
                                  
                                  <v-select :items="kredikarti" hide-details :label="$t('Company-Credit-Card-No')"
                                    v-model="EkstreHesap.FirmaKartNo" item-text="KrediKartNo" clearable
                                    item-value="KrediKartNo" max-height="400"></v-select>

                                  <v-autocomplete hide-details="" clearable :items="itemsairlinelist"
                                    :label="$t('Select-Airline')" item-text="Title" v-model="EkstreHesap.HavayoluKodu"
                                    item-value="HavaYoluKodu">

                                  </v-autocomplete>
                                </v-layout>
                              </v-card-actions>
                            </v-card>
                          </v-card>
                        </v-flex>

                        <v-layout justify-space-between column>
                          <v-checkbox v-model="EkstreHesap.ServisTutar" :label="$t('Show-Service-Amount-Statement')"
                            hide-details=""></v-checkbox>
                          <v-checkbox v-model="EkstreHesap.ReserveTutar"
                            :label="$t('Dont-Show-Variable-Area-Total-Amount')" hide-details=""></v-checkbox>
                          <v-checkbox v-model="EkstreHesap.CoperKayit" :label="$t('Dont-show-the-records-from-COPER')"
                            hide-details=""></v-checkbox>
                          <v-checkbox v-model="EkstreHesap.CariKayit" :label="$t('Dont-show-entered-from-Current-Transaction')"
                            hide-details=""></v-checkbox>
                          <v-checkbox v-model="EkstreHesap.OzetRapor" :label="$t('Detail-Report')" hide-details=""></v-checkbox>
                          <v-checkbox v-model="tumsirketler" :label="$t('All-Companies')" hide-details=""></v-checkbox>
                        </v-layout>
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>
                        <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{$t('Apply-Filters')}}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>




                </v-layout>
              </v-form>
            </v-card>
          </v-container>
          <v-container v-show="detay==true" fluid="">

            <v-flex xs12 sm12>
              <v-card flat color="grey lighten-4">
                <v-toolbar size="120px" flat="" color="grey lighten-4">
                  <v-toolbar-title class="grey--text"> {{secilenkartno}} {{ $t('Numbered-Company-Card-Extract-Details') }} 
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn dark color="info" flat @click="getListDetayHtml()">
                    <v-icon color="info">get_app </v-icon> Html indir
                  </v-btn>
                  <v-btn dark color="info" flat @click="listeyeDon()">
                    <v-icon color="info">navigate_before </v-icon>  {{ $t('Back-to-List') }}
                  </v-btn>

                </v-toolbar>
                <v-card-text>
                  <v-layout row="" wrap="">
                    <div class="flex md12">
                      <v-data-table :headers="headersservis" :search="searchdetay" :items="detayitems" hide-actions
                        class="elevation-1">
                        <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                        <template slot="items" slot-scope="props">
                          <tr item>
                            <td class="text-xs-left">{{ props.item.Tarih | dateformat }}</td>
                            <td class="text-xs-left">{{ props.item.BiletNo }}</td>
                            <td class="text-xs-left">{{ props.item.Havayolu }}</td>
                            <td class="text-xs-left">{{ props.item.Faturano }}</td>
                            <td class="text-xs-left">{{ props.item.Cari.Kod }}</td>
                            <td class="text-xs-left">{{ props.item.YolcuAdi }}</td>
                            <td class="text-xs-left">{{ props.item.Parkur }}</td>
                            <td class="text-xs-left">{{ props.item.Tutar | moneyformat }}</td>
                            <td class="text-xs-left">
  <v-icon
    :color="
      props.item.TahsilatDurumu === 'Tam Ödendi' ? 'green' :
      props.item.TahsilatDurumu.startsWith('Parçalı Ödendi') ? 'orange' :
      props.item.TahsilatDurumu === 'Ödenmedi' ? 'red' : 'grey'
    "
    small
    class="mr-1"
  >lens</v-icon>
  {{ props.item.TahsilatDurumu }}
</td>


                          </tr>
                        </template>
                      </v-data-table>
                    </div>
                  </v-layout>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>

                </v-card-actions>
              </v-card>
            </v-flex>


          </v-container>

        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"
  import tarihcomp from '../customcomp/tarihim'
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import cariaracomp from '@/components/app/customcomp/cariaracomp'

  export default {
    data() {
      return {
        mailDialog: false,
mailValid: false,
mailLoading: false,
mailPayload: {
  To: "",
  AgencyName: "",
  DocType: "Firma Kart Ekstresi - Statement of Account by Company Credit Card", 
  AgentFullName: "",
  CustomBody: ""
},
rules: {
  required: v => !!v || 'Zorunlu alan',
  email: v => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Geçerli bir e-posta girin'
},
        PB:'TRY',
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        filtrevarmi: false,
        detay: false,
        searchdetay: null,
        search: '',
        valid: true,
        headers: [{
            text: this.$t('Card-Number'),
            sortable: false,
            value: 'FirmaKartNo'
          },
          {
            text: this.$t("totalamount"),
            value: 'ToplamAdet'
          }, {
            text: this.$t('Total-Services'),
            value: 'ToplamServis',
            align: 'right'
          },

          {
            text: this.$t("totalamount"),
            value: 'ToplamTutar',
            align: 'right'
          }

        ],
        headers2: [{
            text: this.$t('Currentcode_label'),
            value: 'Current',
            class: "background-color:#E0E0E0;"
          },
          {
            text: this.$t('Date'),
            value: 'Date',
            class: "background-color:#E0E0E0;"
          }
        ],


        headersservis: [{
            text: this.$t('Date'),
            sortable: false,
            value: 'Tarih'
          },
          {
            text: this.$t('Ticket-No'),
            value: 'BiletNo'
          }, {
            text: this.$t('Airline-Code'),
            value: 'Havayolu'
          },

          {
            text: this.$t('Invoice-No'),
            value: 'Faturano'
          },

          {
            text: this.$t('Currentcode_label'),
            value: 'Cari.Kod'
          },

          {
            text: this.$t('Name-of-Passenger'),
            value: 'YolcuAdi'
          },

          {
            text: this.$t('Route'),
            value: 'Parkur'
          },

          {
            text: this.$t('Amount'),
            value: 'Tutar'
          },
          {
            text: "Tahsilat Durumu",
            value: 'TahsilatDurumu'
          }

        ],

        EkstreHesap: {
          FirmaKartNo: '',
          BaslangicTarih: '',
          BitisTarih: '',
          CariKod: '',
          HavayoluKodu: '',
          ServisTutar: '',
          ReserveTutar: '',
          CoperKayit: '',
          CariKayit: '',
          SirketKodu: '',
          OzetRapor: false
        },
        tumsirketler: '',
        totalCount: 0,
        totalService: 0,
        totalAmount: 0,
        StartDate: null,
        EndDate: null,
        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        date2: null,
        menu2: false,
        dateFormatted2: '',
        modal2: false,
        loading: false,
        items: [],
        load: false,
        load1: true,
        search3: '',
        detayitems: [],
        renk1: 'info',
        dialogfiltre: false,
        hesapkodu: [],
        kredikarti: [],
        statecari: [],
        itemsairlinelist: [],
        searchcari: '',
        progress: false,
        secilenkartno: null,

        dictionary: {
          custom: {

            tarihsec: {
              required: () => this.$t('Please-select-a-date')
            },
            tarihsec1: {
              required: () => this.$t('Please-select-a-date')
            },
          }
        },

        dialog: false,
        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        tooltip: false,
        el: null,
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    beforeMount: beforeMount,
    components: {
      tarihcomp,
      yetkidialog,
      cariaracomp
    },
    mounted() {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.PB=credentials.ParaBirimi
      this.$validator.localize('en', this.dictionary)
      this.el = this.$refs.fab.$el

      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {

      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          } 

        });

      }

    },
    watch: {
    },
    filters: {

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },
    methods: {
      openMailDialog() {
  try {
    const credentials = JSON.parse(window.localStorage.getItem('credentials')) || {};
    if (!this.mailPayload.AgentFullName && credentials.UserName) {
      this.mailPayload.AgentFullName = credentials.UserName;
    }
  } catch (e) {}
  this.mailDialog = true;
},

closeMailDialog() {
  this.mailDialog = false;
},

async sendMail() {
  if (!this.$refs.mailForm.validate()) return;

  const url = auth.API_URL + 'api/Abstract/MailGonderFirmaKartEkstre';

  const credentials = JSON.parse(window.localStorage.getItem('credentials')) || {};

  const basT = this.date ? String(this.date).slice(0, 10) : this.EkstreHesap.BaslangicTarih;
  const bitT = this.date2 ? String(this.date2).slice(0, 10) : this.EkstreHesap.BitisTarih;

  const firmaKartNo =
    (this.EkstreHesap && this.EkstreHesap.FirmaKartNo) || this.secilenkartno || '';

  const input = {
    BaslangicTarih: basT,
    BitisTarih: bitT,
    FirmaKartNo: firmaKartNo,
    CariKod: this.EkstreHesap.CariKod || '',
    HavayoluKodu: this.EkstreHesap.HavayoluKodu || '',
    ServisTutar: !!this.EkstreHesap.ServisTutar,
    ReserveTutar: !!this.EkstreHesap.ReserveTutar,
    CoperKayit: !!this.EkstreHesap.CoperKayit,
    CariKayit: !!this.EkstreHesap.CariKayit,
    OzetRapor: !!this.EkstreHesap.OzetRapor,
    SirketKodu: this.tumsirketler ? 0 : credentials.SirketKodu
  };

  const mail = {
    To: (this.mailPayload.To || '').trim(),
    AgencyName: (this.mailPayload.AgencyName || '').trim(),
    DocType: (this.mailPayload.DocType || '').trim(),
    AgentFullName: (this.mailPayload.AgentFullName || '').trim(),
    CustomBody: (this.mailPayload.CustomBody || '').trim()
  };

  const request = { Input: input, Mail: mail };

  this.mailLoading = true;
  try {
    await this.$http.post(url, request, {
      headers: {
        Authorization: 'Bearer ' + auth.getAuthHeader(),
        'Content-Type': 'application/json'
      }
    });
    this.text1 = 'Mail gönderildi.';
    this.snackbar = true;
    this.closeMailDialog();
  } catch (err) {
    var msg = body.Message || body.message || 'Mail gönderilemedi.';
    this.text1 = msg;
    this.snackbar = true;
  } finally {
    this.mailLoading = false;
  }
},

         getparabirimi() {
        return helpers.getparabirimi()
      },
      listeyeDon() {
        this.detay = false;
      },
      getir(id, kartno) {
        this.secilenkartno = kartno
        this.detayitems = id
        this.dialog = true
        this.detay = true;


      },

      getList: getList,
      getListHtml: getListHtml,
      getListDetayHtml: getListDetayHtml,
      getListExcel: getListExcel,

      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal
    }
  }


  function filtrele() {
    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params3 = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/FirmCard/List', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.kredikarti = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = this.$t('No-Records-Found')
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })

  }

  function filtrekayit() {
    this.filtrevarmi = true
    this.dialogfiltre = false
    this.getList();
  }

  function filtreiptal() {
    this.filtrevarmi = false
    this.dialogfiltre = false

  }

  function getList() {


    if (this.$refs.formtarih.validate()) {

      var bastarih = new Date(this.date)
      var bittarih = new Date(this.date2)

      if (bastarih <= bittarih) {
        this.progress = true
        this.load1 = false



        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler === true) {
          this.EkstreHesap.SirketKodu = '0'
        } else {
          this.EkstreHesap.SirketKodu = credentials.SirketKodu
        }

        this.EkstreHesap.BaslangicTarih = this.date
        this.EkstreHesap.BitisTarih = this.date2

        var params = this.EkstreHesap

        this.$http.post(auth.API_URL + 'api/Abstract/ListWithFirmCart', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          var toplamadet = 0
          var toplamtutar = 0

          if (response.body[0].ToplamAdet != 0) {

            this.items = response.body

            response.body.forEach(element => {
              toplamtutar = toplamtutar + element.ToplamTutar
              toplamadet = toplamadet + element.ToplamAdet
            });



            this.text1 =   toplamadet + ' ' + this.$t('Number-of-Records-Found')
            this.snackbar = true
            this.totalCount = toplamadet
            this.totalAmount = toplamtutar

          } else {
            this.items = []
            this.text1 ='0' + ' ' + this.$t('Number-of-Records-Found')
            this.snackbar = true
          }

          this.progress = false
          this.load1 = true

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })

      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }
  }

  function getListDetayHtml() {


    var params = {
      BaslangicTarih: this.date,
      BitisTarih: this.date2,
      FirmaKartNo: this.secilenkartno,
      OzetRapor: true
    }


    this.$http
      .post(auth.API_URL + "api/Abstract/ListWithFirmCartHtml", params, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader()
        }
      }).then((response) => {
        this.progress = false
        this.load1 = true
        var blob = new Blob([response.data], {
          type: 'application/html'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = "FirmaKartEkstre.html";
        link.click();
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.progress = false
          this.load1 = true
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.progress = false
          this.load1 = true
        }
      })
  }

  function getListHtml() {

    this.totalCount = 0,
      this.totalService = 0,
      this.totalAmount = 0,

      this.progress = true
    this.load1 = false


    if (this.date == null) {
      this.date = getDateNow()
    }

    if (this.date2 == null) {
      this.date2 = getDateNow()
    }


    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    var lang = localStorage.getItem('lang')
    if (this.tumsirketler === true) {
      this.EkstreHesap.SirketKodu = '0'
    } else {
      this.EkstreHesap.SirketKodu = credentials.SirketKodu
    }

    this.EkstreHesap.BaslangicTarih = this.date
    this.EkstreHesap.BitisTarih = this.date2



    var params = this.EkstreHesap


    this.$http
      .post(auth.API_URL + "api/Abstract/ListWithFirmCartHtml", params, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader()
        }
      }).then((response) => {

          if (lang=='en')
          {
             var bodyhtml=helpers.getTranslatedHtml(response.bodyText);
             bodyhtml=bodyhtml.toString().replace('<title> FİRMA KART EKSTRESİ </title>','<title> EXTRACT BY FIRM CARD </title>');
             bodyhtml=bodyhtml.toString().replace("<font face = 'Arial' size = '4' color = '#FFFFF0'>FİRMA KART EKSTRESİ</font>","<font face = 'Arial' size = '4' color = '#FFFFF0'>EXTRACT BY FIRM CARD</font>")
             response.bodyText=bodyhtml;
          }

        this.progress = false
        this.load1 = true
        var blob = new Blob([response.bodyText], {
          type: 'application/html'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = this.$t('FirmCardExtract') + ".html";
        link.click();

      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.progress = false
          this.load1 = true
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.progress = false
          this.load1 = true
        }
      })


    this.$http.post(auth.API_URL + 'api/Abstract/ListWithFirmCart', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      var toplamadet = 0
      var toplamtutar = 0

      if (response.body[0].ToplamAdet != 0) {

        this.items = response.body

        response.body.forEach(element => {
          toplamtutar = toplamtutar + element.ToplamTutar
          toplamadet = toplamadet + element.ToplamAdet
        });



        this.text1 =   toplamadet + ' ' + this.$t('Number-of-Records-Found')
        this.snackbar = true
        this.totalCount = toplamadet
        this.totalAmount = toplamtutar.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')

      } else {
        this.items = []
        this.text1 = '0' + ' ' + this.$t('Number-of-Records-Found')
        this.snackbar = true
      }

      this.progress = false
      this.load1 = true

    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.progress = false
        this.load1 = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.progress = false
        this.load1 = true
      }
    })



  }

  function getListExcel() {

    this.totalCount = 0,
      this.totalService = 0,
      this.totalAmount = 0,

      this.progress = true
    this.load1 = false


    if (this.date == null) {
      this.date = getDateNow()
    }

    if (this.date2 == null) {
      this.date2 = getDateNow()
    }


    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    if (this.tumsirketler === true) {
      this.EkstreHesap.SirketKodu = '0'
    } else {
      this.EkstreHesap.SirketKodu = credentials.SirketKodu
    }

    this.EkstreHesap.BaslangicTarih = this.date
    this.EkstreHesap.BitisTarih = this.date2



    var params = this.EkstreHesap


    this.$http
      .post(auth.API_URL + "api/Abstract/ListWithFirmCartExcel", params, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader()
        },
        responseType: "arraybuffer"
      }).then((response) => {
        this.progress = false
        this.load1 = true
        var blob = new Blob([response.data], {
          type: 'application/xlsx'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = this.$t('FirmCardExtract') + ".xlsx";
        link.click();


      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.progress = false
          this.load1 = true
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.progress = false
          this.load1 = true
        }
      })



    this.$http.post(auth.API_URL + 'api/Abstract/ListWithFirmCart', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      var toplamadet = 0
      var toplamtutar = 0

      if (response.body[0].ToplamAdet != 0) {

        this.items = response.body

        response.body.forEach(element => {
          toplamtutar = toplamtutar + element.ToplamTutar
          toplamadet = toplamadet + element.ToplamAdet
        });



        this.text1 =  toplamadet + ' ' + this.$t('Number-of-Records-Found')
        this.snackbar = true
        this.totalCount = toplamadet
        this.totalAmount = toplamtutar.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')

      } else {
        this.items = []
        this.text1 = '0' + ' ' + this.$t('Number-of-Records-Found')
        this.snackbar = true
      }

      this.progress = false
      this.load1 = true

    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.progress = false
        this.load1 = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.progress = false
        this.load1 = true
      }
    })

  }

  function beforeMount() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.itemsairlinelist = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      }
    })
  }
</script>
<style>

</style>